import { CoordNotesServiceImplFactory } from "../../core/impl/coordNotesServiceImpl";

export const CoordNotesControllerFactory = ({
  coordNotesService,
}: {
  coordNotesService: ReturnType<typeof CoordNotesServiceImplFactory>;
}) => {
  const getNotes = async ({
    clinicId,
    patientId,
    limit,
    offset,
  }: {
    clinicId: number;
    patientId: number;
    limit?: number;
    offset?: number;
  }) => {
    try {
      const result = await coordNotesService.getNotes({
        clinicId,
        patientId,
        limit,
        offset,
      });
      if (result.success && result.data)
        return { success: true as const, data: result.data };
      return {
        success: false as const,
        error: !result.success ? result.error : { message: "No data returned" },
      };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  const createNote = async ({
    clinicId,
    patientId,
    noteText,
  }: {
    clinicId: number;
    patientId: number;
    noteText: string;
  }) => {
    try {
      const result = await coordNotesService.createNote({
        clinicId,
        patientId,
        noteText,
      });
      if (result.success && result.data)
        return { success: true as const, data: result.data };
      return {
        success: false as const,
        error: !result.success ? result.error : { message: "No data returned" },
      };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  const deleteNote = async ({
    clinicId,
    patientId,
    noteId,
  }: {
    clinicId: number;
    patientId: number;
    noteId: number;
  }) => {
    try {
      const result = await coordNotesService.patchNote({
        clinicId,
        patientId,
        noteId,
        status: 0,
      });
      if (result.success) return { success: true as const, data: result.data };
      return {
        success: false as const,
        error: !result.success ? result.error : { message: "No data returned" },
      };
    } catch (error) {
      return {
        success: false as const,
        error: { message: (error as Error).message },
      };
    }
  };

  return { getNotes, createNote, deleteNote };
};
